module.exports = __webpack_public_path__ + "img/confrontation.f82fca8b.svg";